import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { BsFillCheckCircleFill, BsFillExclamationDiamondFill, BsCircleFill } from 'react-icons/bs';
import { TbConfetti } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Api from "../../services/ApiService";
import { useAuthDispatch } from "../../context/AuthContext";

/**
 * DoneComponent
 * 
 * shows customer message that forms fill are done
 * 
 * @returns None
 */
const DoneComponent = ({data, setApiError, setStep}) => {

    const API = new Api();
    const dispatch = useAuthDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isRegistrationDone, setIsRegistrationDone] = useState(false);

    useEffect(() => {
        var cleanData = {...data};
        if (data.partner.x_file_ausweiskopie !== "" && data.partner.x_file_ausweiskopie.includes(',')) {
            cleanData.partner.x_file_ausweiskopie = data.partner.x_file_ausweiskopie.split(",")[1];
        }
        cleanData.partner.x_account_iban = cleanData.partner.x_account_iban.replaceAll(/\s+/g, '');

        if (cleanData.partner.id === null) {
            delete cleanData.partner.id;
        }
        console.log(cleanData);
        
        API.register_complete(cleanData)
            .then(res => {
                setIsLoading(false);
                setIsRegistrationDone(true);
                localStorage.removeItem('customer');
                let user = res.data.partner;

                if (data.mailRegister === undefined || data.mailRegister === false) {
                    dispatch("LOGIN", user);

                    delete res.data['partner'];
                    localStorage.setItem("token", JSON.stringify(res.data));
                }
            })
            .catch(err => {
                if (err.code === "ERR_NETWORK") {
                    setApiError("Keine Verbindung zum Server, versuchen sie später.");
                } else {
                    if (err.response.data.detail !== undefined) {
                        setApiError(err.response.data.detail)
                    } else {
                        setApiError("Unbekannter Fehler.")
                    }
                }
                setStep("!");
                setIsLoading(false);
            })
    }, [])

    return (
        <div className="mt-5 mb-5">
            {isLoading &&
                <div className="text-center">
                    <p>Ihre Daten werden verarbeitet.</p>
                    <Spinner animation="grow" className="btn-energo" />&nbsp;
                    <Spinner animation="grow" className="btn-energo" />&nbsp;
                    <Spinner animation="grow" className="btn-energo" />
                </div>
            }
            {isRegistrationDone &&
                <div className="text-center">
                    <Row className="mb-5">
                        <div className="animate__animated animate__backInRight">
                            <TbConfetti size={80} className="text-energo animate__animated animate__tada animate__delay-2s" />
                        </div>
                        <h5 className="text-energo">Fertig</h5>
                    </Row>
                    <Row>
                        {data.mailRegister && data.mailRegister === true?
                            <Col xs="12">
                                <p>
                                    Vielen Dank für Ihre Registrierung. Wir pflegen nun Ihre Daten ein und kommen 
                                    so bald wie möglich auf Sie zurück, wenn alles erledigt ist! <br /><br />
                                    Sie können diese Webseite schließen, oder wechseln Sie auf unsere Webseite. <br/><br />
                                    Mit besten Grüßen
                                </p>
                                <a href="https://energiepool.at/" className="btn btn-energo">Zur Webseite</a>
                            </Col> :
                            <Col xs="12">
                                <p>Vielen Dank für Ihre Registrierung. Sie können das ENERGO Managementportal ab jetzt nutzen.</p>
                                <Button className="btn-energo" onClick={() => navigate("/dashboard")}>Zum Portal</Button>
                            </Col>
                        }
                    </Row>
                </div>
            }
        </div>
    )
}

export default DoneComponent;